import { render, staticRenderFns } from "./uppy_booking.vue?vue&type=template&id=5003edbb&scoped=true"
import script from "./uppy_booking.vue?vue&type=script&lang=js"
export * from "./uppy_booking.vue?vue&type=script&lang=js"
import style0 from "./uppy_booking.vue?vue&type=style&index=0&id=5003edbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003edbb",
  null
  
)

export default component.exports